import React from 'react';
import {
  Box,
  Typography,
  Button,
  IconButton,
  Stack,
  Avatar,
  Drawer,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';
import BoltIcon from '@mui/icons-material/Bolt';

const SessionsDrawer = ({ open, onClose, admin, getFullImageUrl }) => {
  if (!admin) return null;

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1000,
        '& .MuiDrawer-paper': {
          width: { xs: '100%', sm: 500 },
          border: 'none',
          backgroundColor: '#F4F7FE',
        },
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        {/* HEADER */}
        <Box
          sx={{
            p: 3,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            bgcolor: 'white',
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 800, color: '#2B3674' }}>
            Détails des Sessions en ligne
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* CONTENU */}
        <Box sx={{ flexGrow: 1, overflowY: 'auto', p: 3 }}>
          <Box
            sx={{
              mb: 4,
              p: 3,
              borderRadius: '20px',
              bgcolor: 'white',
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Avatar
              src={getFullImageUrl(admin.image_user)}
              sx={{ width: 60, height: 60 }}
            />
            <Box>
              <Typography sx={{ fontWeight: 800, color: '#2B3674' }}>
                {admin.nom_user} {admin.prenom_user}
              </Typography>
              <Typography variant="body2" sx={{ color: '#A3AED0' }}>
                {admin.user_sessions?.length || 0} sessions enregistrées
              </Typography>
            </Box>
          </Box>

          <Typography
            variant="subtitle2"
            sx={{
              color: '#A3AED0',
              fontWeight: 700,
              mb: 2,
              ml: 1,
              textTransform: 'uppercase',
            }}
          >
            Historique
          </Typography>

          <Stack spacing={2}>
            {admin.user_sessions && admin.user_sessions.length > 0 ? (
              admin.user_sessions.map((session) => {
                const isActive = !session.logout_time;
                return (
                  <Box
                    key={session.id_userSession}
                    sx={{
                      p: 2,
                      borderRadius: '16px',
                      bgcolor: 'white',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      border: isActive
                        ? '1px solid #05CD99'
                        : '1px solid transparent',
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '10px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          bgcolor: isActive ? '#E6F9F0' : '#F4F7FE',
                          color: isActive ? '#05CD99' : '#4318FF',
                        }}
                      >
                        {isActive ? <BoltIcon /> : <HistoryIcon />}
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 700,
                            color: '#2B3674',
                            fontSize: '0.85rem',
                          }}
                        >
                          {isActive ? 'En cours' : 'Terminée'}
                        </Typography>
                        <Typography sx={{ color: '#A3AED0', fontSize: '0.75rem' }}>
                          {new Date(session.login_time).toLocaleString('fr-FR')}
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={{ textAlign: 'right' }}>
                      <Typography sx={{ fontWeight: 800, color: '#2B3674' }}>
                        {session.working_minutes || 0} min
                      </Typography>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Typography sx={{ textAlign: 'center', color: '#A3AED0', mt: 4 }}>
                Aucune session trouvée
              </Typography>
            )}
          </Stack>
        </Box>

        {/* FOOTER */}
        <Box sx={{ p: 3, bgcolor: 'white' }}>
          <Button
            fullWidth
            variant="contained"
            onClick={onClose}
            sx={{
              bgcolor: '#4318FF',
              borderRadius: '12px',
              py: 1.5,
              fontWeight: 700,
            }}
          >
            Fermer
          </Button>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SessionsDrawer;
